<script lang="ts">
      import CtaNode from './CtaNode.svelte'

      const table = new Map()

      table.set('cta', CtaNode)

      let { node } = $props()

      let { fields, children = undefined } = $state(node)
      const Element = $state(table.get(fields.blockType))
</script>

{#if Element}
      <Element node={fields}>
            {#if children}
                  {@render children?.()}
            {/if}
      </Element>
{:else}
      {@render children?.()}
{/if}
